import Config from '../config';
import View from './view';





export default View.extend( {
    
    serialize() {
        return {
            languages: Config.languages(),
            locale: Config.locale(),
            systemTitle: Config.title(),
        };
    },

    events: {

        'click .-set-locale'({currentTarget}) {
            const { locale } = currentTarget.dataset;
            Config.locale( locale );
            location.reload();
        },

    }
    
} );


// WEBPACK FOOTER //
// ./src/js/view/core.nav.js